export default "__VITE_ASSET__491836cb__"